import { TokenResponse } from "@openid/appauth/built/token_response";

export class Identity {
  public name: string;

  public claims: Claim[] = [];

  public static createFromResponse(res: TokenResponse): Identity {
    var token = this.decodeToken(res.idToken);

    var id = new Identity();
    id.name = token.name;
    for (var x in token) {
      var vals = [token[x]];
      id.claims.push(new Claim(x, vals));
    }

    return id;
  }

  private static decodeToken(jwt: string): any {
    var arr = jwt.split(".");

    //var header = atob(arr[0]);
    var payload = atob(arr[1]);
    //var signature = arr[2];

    return JSON.parse(payload);
  }
}

export class Claim {
  public name: string
  public values: string[]

  constructor(name: string, values: string[]) {
    this.name = name;
    this.values = values;
  }
}
